import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import {
  BuildingGroupMultiSelect,
  BuildingGroupSelectFormikField,
} from '../../../../BuildingGroup'
import { Checkbox, CHECKBOX_SIZE, CHECKBOX_TYPE } from '../../../../Checkbox'
import { FieldStackedLabel } from '../../../../Field'
import { FormFieldsContainer } from '../../../../Form'
import {
  FormikEntityActionConfigFields,
  FormikField,
  getFormikCheckboxFieldValueProps,
  getFormikFormFieldErrorProps,
  useFormikEntityActionConfigFieldsClearFields,
} from '../../../../Formik'
import {
  BUILDINGS_EDIT_BUILDINGS_GROUP_FIELD_NAME_BUILDING_GROUPS,
  BUILDINGS_EDIT_BUILDINGS_GROUP_FIELD_NAME_UPDATE_MANAGERS,
  EDIT_BUILDINGS_GROUP_FORM_INITIAL_VALUES,
} from '../BuildingsEditBuildingsGroupActionModal.constants'

import * as styles from './FormFields.module.css'

function FormFields({ actionTypes }) {
  const { t } = useTranslation()

  const { errors, setFieldValue, values } = useFormikContext()

  useEffect(() => {
    if (
      values[BUILDINGS_EDIT_BUILDINGS_GROUP_FIELD_NAME_BUILDING_GROUPS]
        .length === 0
    ) {
      setFieldValue(
        BUILDINGS_EDIT_BUILDINGS_GROUP_FIELD_NAME_UPDATE_MANAGERS,
        false
      )
    }
  }, [values[BUILDINGS_EDIT_BUILDINGS_GROUP_FIELD_NAME_BUILDING_GROUPS]])

  const { actionTypeValueIsRemoveAll } =
    useFormikEntityActionConfigFieldsClearFields({
      emptyValues: EDIT_BUILDINGS_GROUP_FORM_INITIAL_VALUES,
    })

  const disabledCheckbox =
    values[BUILDINGS_EDIT_BUILDINGS_GROUP_FIELD_NAME_BUILDING_GROUPS].length ===
      0 && !actionTypeValueIsRemoveAll

  return (
    <FormFieldsContainer>
      <FormikEntityActionConfigFields
        typeSelectProps={{
          error:
            errors[BUILDINGS_EDIT_BUILDINGS_GROUP_FIELD_NAME_BUILDING_GROUPS],
          options: actionTypes,
        }}
      >
        <BuildingGroupSelectFormikField
          multi
          Field={FieldStackedLabel}
          Select={BuildingGroupMultiSelect}
          controlProps={{
            contentProps: {
              inputProps: {
                placeholder: t('Building.GroupsPlaceholderKey'),
              },
            },
          }}
          disabled={actionTypeValueIsRemoveAll}
          fieldComponentProps={{
            label: `${t('Building.GroupLabelKey')}:`,
          }}
          name={BUILDINGS_EDIT_BUILDINGS_GROUP_FIELD_NAME_BUILDING_GROUPS}
        />
        <FormikField
          showTooltip
          Component={Checkbox}
          disabled={disabledCheckbox}
          getErrorProps={getFormikFormFieldErrorProps}
          getValueProps={getFormikCheckboxFieldValueProps}
          label={t('BuildingGroup.UpdateManagersFieldLabelKey')}
          labelClassName={styles.checkboxLabel}
          name={BUILDINGS_EDIT_BUILDINGS_GROUP_FIELD_NAME_UPDATE_MANAGERS}
          size={CHECKBOX_SIZE.small}
          tooltip={
            disabledCheckbox
              ? t('BuildingGroup.UpdateManagersFieldTooltipAddBuildingKey')
              : null
          }
          type={CHECKBOX_TYPE.action}
        />
      </FormikEntityActionConfigFields>
    </FormFieldsContainer>
  )
}

export default FormFields
